module.exports = __webpack_public_path__ + "media/events/RoadShow2019-289ee858.png";